// LAP-646 — Card "Insights rapides" : phrases générées par le backend
import React from 'react'
import { Box, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined'
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined'
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CardHeader from '../../Investments/_shared/CardHeader'
import EmptyHelp from './EmptyHelp'

const ICON_MAP = {
  warning: { Icon: WarningAmberOutlinedIcon, color: '#f59e0b' },
  info: { Icon: InfoOutlinedIcon, color: '#63a0ff' },
  balance: { Icon: BalanceOutlinedIcon, color: '#34d399' },
  celebrate: { Icon: CelebrationOutlinedIcon, color: '#f472b6' },
  trend: { Icon: TrendingUpOutlinedIcon, color: '#a78bfa' },
}

export default function InsightsCard({ data, loading }) {
  const { t } = useTranslation('layout')
  const items = Array.isArray(data) ? data : []
  if (!loading && items.length === 0) {
    return (
      <Box display="flex" flexDirection="column" height="100%">
        <CardHeader
          icon={<AutoAwesomeOutlinedIcon fontSize="small" />}
          title={t('social.insights.title', 'Insights rapides')}
          subtitle={t('social.insights.subtitle', 'Recommandations basées sur ton activité')}
        />
        <EmptyHelp
          icon={<AutoAwesomeOutlinedIcon sx={{ fontSize: 22 }} />}
          title={t('social.empty.insights.title', 'Pas encore assez d’activité pour des insights')}
          description={t(
            'social.empty.insights.description',
            'Les insights sont générés automatiquement à partir de tes interactions (ratio pro / perso, cercles silencieux, mois en hausse ou en baisse…). Crée au moins quelques événements avec des participants pour les faire apparaître.',
          )}
          actions={[
            { key: 'calendar', label: t('social.empty.cta.createEvent', 'Créer un événement') },
            { key: 'contacts', label: t('social.empty.cta.addContact', 'Ajouter un contact') },
          ]}
        />
      </Box>
    )
  }
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <CardHeader
        icon={<AutoAwesomeOutlinedIcon fontSize="small" />}
        title={t('social.insights.title', 'Insights rapides')}
        subtitle={t('social.insights.subtitle', 'Recommandations basées sur ton activité')}
      />
      <Box mt={2} sx={{ flexGrow: 1 }}>
        <Grid container spacing={1.5}>
          {items.map((ins, idx) => {
            const conf = ICON_MAP[ins.icon] || ICON_MAP.info
            const Icon = conf.Icon
            return (
              <Grid item xs={12} sm={6} md={items.length > 2 ? 4 : 6} key={idx}>
                <Box
                  sx={{
                    p: 1.5,
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1.25,
                    borderRadius: 2,
                    background: `linear-gradient(135deg, ${conf.color}18, transparent 70%)`,
                    border: `1px solid ${conf.color}30`,
                    height: '100%',
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      backgroundColor: `${conf.color}25`,
                      color: conf.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <Icon fontSize="small" />
                  </Box>
                  <Box sx={{ fontSize: 13, lineHeight: 1.5, color: 'rgba(255,255,255,0.9)' }}>
                    {ins.text}
                  </Box>
                </Box>
              </Grid>
            )
          })}
        </Grid>
      </Box>
    </Box>
  )
}
